import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import cn from 'classnames';

import BlockDetail from './BlockDetail';
import LinkBack from '../widgets/LinkBack';

import './success-story.scss';

class SuccessStoryTemplate extends PureComponent {
  render() {
    const backgroundImage = this.props.isMobile
      ? this.props.page.background.mobile
      : this.props.page.background.desktop;

    return (
      <div className="success-story">
        {(this.props.page.meta) &&
          <Helmet>
            <title>{this.props.page.meta.title}</title>
          </Helmet>
        }

        <div
          className={cn('success-story-background', this.props.page.name)}
          style={{ backgroundImage: `url(${backgroundImage})` }}
        />

        <div className="container">
          <div className="success-story-content">
            <LinkBack link="/success-stories/subnavigation/">
              истории успеха <i>вернуться</i>
            </LinkBack>
          </div>

          <div className="success-story-panel">
            <BlockDetail
              {...this.props.page}
              story={this.props.story}
              bane={this.props.name}
              onOpenClick={this.props.onOpenClick}
            />
          </div>
        </div>
      </div>
    );
  }
}

SuccessStoryTemplate.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    background: PropTypes.shape({
      desktop: PropTypes.string,
      mobile: PropTypes.string
    }),
    blocks: PropTypes.object.isRequired
  }),
  story: PropTypes.shape({
    profitRate: PropTypes.string,
    dateRate: PropTypes.string,
    programLink: PropTypes.string
  })
};

export default SuccessStoryTemplate;



// WEBPACK FOOTER //
// ./src/components/SuccessStory/SuccessStoryTemplate.js